package com.eladfinish.bible.contest.ui.ads

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * A screen that must not show the bottom ad banner for a while (a ראש בראש room: a timed game
 * against a friend, where a mistaken tap on an ad loses the turn) says so here; the app's
 * scaffold hides the banner meanwhile. The screen clears it when it leaves.
 */
class AdBannerSuppression {

    private val _isSuppressed = MutableStateFlow(false)
    val isSuppressed: StateFlow<Boolean> = _isSuppressed.asStateFlow()

    fun set(isSuppressed: Boolean) {
        _isSuppressed.value = isSuppressed
    }
}
